<template>
  <div>
    <carousel class="slides" :data="slides" :interval="3500" indicator-trigger="hover"></carousel>
    <br />
    <iframe
      width="1280"
      height="720"
      src="https://www.youtube.com/embed/C9QkPz6JZgw"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>

    <br />
    <br />
    <a href="https://www.badabusiness.com/dd/BIMK003866" target="_blank" rel="noopener noreferrer">
      <button>Register For The Event</button>
    </a>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { codes } from "../store/contry_codes.js";
export default {
  metaInfo: {
    title: "World's Largest Webinar - How to Start A Start Up",
  },
  data() {
    return {
      slides: [],
      name: "",
      phCode: "",
      phone: "",
      email: "",
      codes,
    };
  },
  methods: {
    submit() {},
  },
  created() {
    var img = document.createElement("img");
    var alt = [
      "World's Largest Webinar | How to Start A Start Up | For Solopreneures & Students",
    ];
    for (var i = 0; i < 22; i++) {
      img.src = require(`../assets/start_up/k${i + 1}.jpg`);
      img.style.maxWidth = "100%";
      img.style.maxHeight = "85vh";
      this.slides.push(img.outerHTML);
    }
  },
};
</script>
<style scoped>
</style>